// eslint-disable-next-line no-shadow
export enum CustomerType {
  INDIVIDUAL = 'INDIVIDUAL',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
}

export enum CustomerDetailsFlowType {
  INDIVIDUAL = 'INDIVIDUAL',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  COCONTRACTOR = 'COCONTRACTOR',
}

/**
 * Represents the group to which the `entityLegalForm` of a customer's company belongs.
 *
 * This grouping is used to simplify logic when working with different legalEntity forms of companies.
 * It is especially useful for applying restrictions on allowed changes to a customer's `entityLegalForm`.
 * For example, you can prevent switching from a sole trader to a non-sole trader form or vice versa.
 * If there is no user, all values are shown.
 */
export enum EntityLegalFormGroup {
  SoleTrader = 'SOLE_TRADER',
  NonSoleTrader = 'NON_SOLE_TRADER',
  None = 'NONE',
}

export enum FinancialProductType {
  FINANCING = 'FINANCING',
}

// eslint-disable-next-line no-shadow
export enum InfoToRenderType {
  MILEAGE_PRICE_AMOUNT = 'mileagePriceAmount',
  VEHICLE_TOTAL_COST = 'vehicleTotalCost',
  BONUS_DEALER_PART = 'SBonus&DealerPart',
  DOCUMENTS_PRINTING = 'documentsPrinting',
  SUMMARY_OF_VEHICLE = 'summaryOfVehicle',
  LCD_WARNING = 'lcdWarning',
  PUSH_VO_WARNING = 'pushVoWarning',
}

// eslint-disable-next-line no-shadow
export enum VehiclePriceTypes {
  HT = 'HT',
  TTC = 'TTC',
}

export enum AddressType {
  PRIMARY = 'Primary',
  INVOICE = 'Invoice',
}

export enum CustomerDetailsSection {
  CONTACT_INFO = 'CONTACT_INFO',
  ADDRESS_INFO = 'ADDRESS_INFO',
  PAYMENT_INFO = 'PAYMENT_INFO',
  GENERAL_INFO = 'GENERAL_INFO',
  ADDRESS_BUSINESS_INFO = 'ADDRESS_BUSINESS_INFO',
  ADDITIONAL_INFO = 'ADDITIONAL_INFO',
  CONTACT_COCO_INFO = 'CONTACT_COCO_INFO',
  ADDRESS_COCO_INFO = 'ADDRESS_COCO_INFO',
  FINANCIAL_INFO = 'FINANCIAL_INFO',
  FINANCIAL_COCO_INFO = 'FINANCIAL_COCO_INFO',
  COMPANY_COCO_INFO = 'COMPANY_COCO_INFO',
  COMPANY_INFO = 'COMPANY_INFO',
  NONE = 'NONE',
  PERSONAL_INFO = 'PERSONAL_INFO',
  ASSIGNER_INFO = 'ASSIGNER_INFO',
  EXECUTIVE_INFO = 'EXECUTIVE_INFO',
  SIGNATORY_INFO = 'SIGNATORY_INFO',
}

export enum CountryDefaultValue {
  FRANCE = 'France',
}

export enum EnumCommercialVehicleTransform {
  restore = 'Applicable; dealer restore',
  noRestore = 'Applicable; dealer will not restore',
}

/**
 * @deprecated DO NOT USE. Ideally remove usage if you have the chance.
 */
export enum EnumCountryCode {
  FRANCE = '99999',
}

export enum EnumProfession {
  INVALIDS = 'INVALIDS',
  STUDENTS = 'STUDENTS',
  NO_ACTIVITY_PLUS_60 = 'NO_ACTIVITY_PLUS_60',
  NO_ACTIVITY_LESS_60 = 'NO_ACTIVITY_LESS_60',
  UNEMPLOYED = 'UNEMPLOYED',
  COMPANY_MANAGER = 'COMPANY_MANAGER',
  PENSIONER = 'PENSIONER',
  TREDSMAN = 'TREDSMAN',
  ENTERPRETEUR = 'ENTERPRETEUR',
  FREELANCER = 'FREELANCER',
  AGRICULTURER = 'AGRICULTURER',
}

export enum BooleanEnum {
  true = 'true',
  false = 'false',
}

export enum QuoteFlow {
  COPY = 'QUOTE_COPY',
  MODIFY = 'QUOTE_MODIFY',
  NEW = 'QUOTE_NEW',
}

export const enum QuoteStatusId {
  'Waiting' = '20',
  'Web Initial' = '100041',
  'Escalated' = '100607',
  'Web Failed' = '100043',
  'Web Initial Dealer' = '100792',
  'Validated' = '23',
  'Manually Validated' = '100056',
  'Web Calculated' = '100042',
  'Web Saved' = '100044',
  'Web Printed/Emailed' = '100722',
  'AFSP refused' = '400768',
  'Refus AFST' = '400767',
  'Canceled' = '22',
  'Credit refused' = '100175',
  'Web Canceled' = '100045',
  'Expired' = '100051',
  'Approved' = '21',
  'Credit decision pending' = '100623',
  'Action required' = '100622',
  'Credit subject to conditions' = '100180',
  'Credit (pre-)approved' = '100174',
  'Contract created' = '100176',
  'Credit stipulations needed' = '400736',
  'Additional stipulations needed' = '400737',
  'Accepté sous réserve' = '401186',
  'Refus' = '401188',
  'Etude' = '401185',
  'Accepté définitif' = '401187',
}

export enum DealerDashboardSubpage {
  Studies = 'Studies',
  Run = 'Run',
  Accepted = 'Accepted',
  Summary = 'Summary',
  Conversations = 'Conversations',
}

export enum KnownSearchParams {
  cid = 'cid',
}

export enum VolkswagenLabels {
  VOLKSWAGEN_NUTZFAHRZEUGE = 'Volkswagen Nutzfahrzeuge',
  VW_LCV = 'Volkswagen Utilitaires',
}
